import { render, staticRenderFns } from "./UpsertWidgetSetting.vue?vue&type=template&id=f514b378&"
import script from "./UpsertWidgetSetting.vue?vue&type=script&lang=ts&"
export * from "./UpsertWidgetSetting.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/llv-unitadmin/llv-unitadmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f514b378')) {
      api.createRecord('f514b378', component.options)
    } else {
      api.reload('f514b378', component.options)
    }
    module.hot.accept("./UpsertWidgetSetting.vue?vue&type=template&id=f514b378&", function () {
      api.rerender('f514b378', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modals/UpsertWidgetSetting.vue"
export default component.exports